(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var Filter = (function () {
	function Filter() {
		_classCallCheck(this, Filter);

		this.initFilter();
	}

	_createClass(Filter, [{
		key: 'initFilter',
		value: function initFilter() {
			if ($('[data-change-filter-behavior]').length) {
				this.initFilterEvents();
			}
		}
	}, {
		key: 'initFilterEvents',
		value: function initFilterEvents() {
			var $filterBehaviorChangeElement = $('[data-change-filter-behavior]'),
			    $filterWrapper = $('[data-filter-mode]'),
			    $window = $(window),
			    docViewTop = undefined,
			    $filterBehaviorChangeElementTop = $filterBehaviorChangeElement.offset().top,
			    lastScrollTop = 0;

			$window.scroll(function () {
				docViewTop = $(this).scrollTop();

				if (docViewTop > lastScrollTop) {

					if ($filterBehaviorChangeElementTop > docViewTop) {
						$filterWrapper.attr('data-filter-mode', 'show');
					} else {
						$filterWrapper.attr('data-filter-mode', 'hide');
					}
				} else {
					$filterWrapper.attr('data-filter-mode', 'show');
				}
				lastScrollTop = docViewTop;
			});
		}
	}]);

	return Filter;
})();

exports['default'] = Filter;
module.exports = exports['default'];

},{}],2:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var Hero = (function () {
	function Hero() {
		_classCallCheck(this, Hero);

		this.initCarousel();
	}

	_createClass(Hero, [{
		key: 'initCarousel',
		value: function initCarousel() {
			var $heroCarousel = $('.owl-hero-carousel'),
			    $textCarousel = $('.owl-text-carousel');

			if ($heroCarousel.length) {
				$heroCarousel.owlCarousel({
					navigation: false,
					pagination: false,
					singleItem: true,
					lazyLoad: true,
					slideSpeed: 500,
					afterMove: this.movedHero
				});
			}

			if ($textCarousel.length) {
				$textCarousel.owlCarousel({
					navigation: false,
					pagination: false,
					singleItem: true,
					lazyLoad: true,
					slideSpeed: 500,
					afterMove: this.movedText
				});
			}

			this.initCarouselEvents();
		}
	}, {
		key: 'initCarouselEvents',
		value: function initCarouselEvents() {
			var heroCarousel = $('.owl-hero-carousel').data('owlCarousel');

			$('[data-hero-arrow-prev]').on('click', function () {
				heroCarousel.prev();
			});

			$('[data-hero-arrow-next]').on('click', function () {
				heroCarousel.next();
			});
		}
	}, {
		key: 'movedHero',
		value: function movedHero() {
			var heroCarousel = $('.owl-hero-carousel').data('owlCarousel'),
			    textCarousel = $('.owl-text-carousel').data('owlCarousel');

			if (textCarousel && heroCarousel.currentItem !== textCarousel.currentItem) {
				textCarousel.goTo(heroCarousel.currentItem);
			}
		}
	}, {
		key: 'movedText',
		value: function movedText() {
			var heroCarousel = $('.owl-hero-carousel').data('owlCarousel'),
			    textCarousel = $('.owl-text-carousel').data('owlCarousel');

			if (textCarousel && heroCarousel.currentItem !== textCarousel.currentItem) {
				heroCarousel.goTo(textCarousel.currentItem);
			}
		}
	}]);

	return Hero;
})();

exports['default'] = Hero;
module.exports = exports['default'];

},{}],3:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _utilsAppAnalytics = require('./utils/app.analytics');

var _utilsAppAnalytics2 = _interopRequireDefault(_utilsAppAnalytics);

var _utilsAppPerformance = require('./utils/app.performance');

var _utilsAppPerformance2 = _interopRequireDefault(_utilsAppPerformance);

var _utilsAppSvg = require('./utils/app.svg');

var _utilsAppSvg2 = _interopRequireDefault(_utilsAppSvg);

var _utilsAppHandlebarshelpers = require('./utils/app.handlebarshelpers');

var _utilsAppHandlebarshelpers2 = _interopRequireDefault(_utilsAppHandlebarshelpers);

var _utilsAppForm = require('./utils/app.form');

var _utilsAppForm2 = _interopRequireDefault(_utilsAppForm);

var _appHero = require('./app.hero');

var _appHero2 = _interopRequireDefault(_appHero);

var _appFilter = require('./app.filter');

var _appFilter2 = _interopRequireDefault(_appFilter);

var _appSearch = require('./app.search');

var _appSearch2 = _interopRequireDefault(_appSearch);

var _appOverlay = require('./app.overlay');

var _appOverlay2 = _interopRequireDefault(_appOverlay);

var _appProject = require('./app.project');

var _appProject2 = _interopRequireDefault(_appProject);

var App = (function () {
	function App() {
		_classCallCheck(this, App);
	}

	_createClass(App, [{
		key: 'init',
		value: function init() {
			this.appAnalytics = new _utilsAppAnalytics2['default']();
			this.appPerformance = new _utilsAppPerformance2['default']();
			this.appSvg = new _utilsAppSvg2['default']();
			this.appHandlebarHelpers = new _utilsAppHandlebarshelpers2['default']();
			this.appForm = new _utilsAppForm2['default']();

			this.hero = new _appHero2['default']();
			this.filter = new _appFilter2['default']();
			this.search = new _appSearch2['default']();
			this.overlay = new _appOverlay2['default']();
			this.project = new _appProject2['default']();

			this.initMobileNavigation();
			this.initCategorySelect();
			this.initAboutSelect();
			this.initAboutSectionOpener();
			this.initIntroSelect();

			if ($('.package-container--judge').length > 1) {
				$('.package-container--judge:eq(1)').addClass('package-container--secondary');
			}
		}
	}, {
		key: 'initMobileNavigation',
		value: function initMobileNavigation() {
			$('[data-mobile-menu]').on({
				'click tap': function clickTap() {
					_utilsAppPerformance2['default'].getCachedDom().$html.toggleClass('menu-open');
				}
			});

			$('nav a').on({
				'click tap': function clickTap() {
					_utilsAppPerformance2['default'].getCachedDom().$html.removeClass('menu-open');
				}
			});
		}
	}, {
		key: 'initCategorySelect',
		value: function initCategorySelect() {
			$('[data-scrollto-category]').on({
				'click tap': function clickTap() {
					var offsetY = 50,
					    $categoryContent = $('.category-content');

					if ($categoryContent.length > 0) {
						if ($('.filter-wrapper').length > 0 && $(window).scrollTop() >= $categoryContent.offset().top) {
							offsetY += 80;
						}

						_utilsAppPerformance2['default'].getCachedDom().$htmlbody.animate({ scrollTop: $categoryContent.offset().top - offsetY }, 500);
					}
				}
			});
		}
	}, {
		key: 'initAboutSelect',
		value: function initAboutSelect() {
			$('[data-scrollto-about]').on({
				'click tap': function clickTap() {
					if ($('.about-content').length > 0) {
						_utilsAppPerformance2['default'].getCachedDom().$htmlbody.animate({ scrollTop: $('.about-content').offset().top - 50 }, 500);
					}
				}

			});
		}
	}, {
		key: 'initIntroSelect',
		value: function initIntroSelect() {
			$('[data-scrollto-intro]').on({
				'click tap': function clickTap() {
					if ($('.introduction-content').length > 0) {
						_utilsAppPerformance2['default'].getCachedDom().$htmlbody.animate({ scrollTop: $('.introduction-content').offset().top - 50 }, 500);
					}
				}

			});
		}
	}, {
		key: 'initAboutSectionOpener',
		value: function initAboutSectionOpener() {
			$('[data-about-text-opener]').on({
				'click tap': function clickTap() {
					$('.about-content__hidden-on-mobile').addClass('open');
					$('.about-content__opener').addClass('hide');
				}
			});
		}
	}]);

	return App;
})();

exports['default'] = App;
module.exports = exports['default'];

},{"./app.filter":1,"./app.hero":2,"./app.overlay":4,"./app.project":5,"./app.search":6,"./utils/app.analytics":8,"./utils/app.form":9,"./utils/app.handlebarshelpers":10,"./utils/app.performance":11,"./utils/app.svg":12}],4:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var Overlay = (function () {
	function Overlay() {
		_classCallCheck(this, Overlay);

		this.overlayIndex = 0;
		this.template = Handlebars.compile($('#overlay-project-items').html());

		if ($('[data-project-item]').length) {
			this.playerOrigin = '*';
			this.init();
		}
	}

	_createClass(Overlay, [{
		key: 'init',
		value: function init() {
			this.initBindings();
		}
	}, {
		key: 'updateOverlayCarousel',
		value: function updateOverlayCarousel() {
			var _this = this;

			if (this.$overlayCarousel.length) {
				this.$overlayCarousel.owlCarousel({
					navigation: true,
					navigationText: false,
					pagination: false,
					singleItem: true,
					mouseDrag: true,
					touchDrag: true,
					lazyLoad: true,
					slideSpeed: 500,
					startDragging: function startDragging() {
						_this.pauseVideo();
					}
				});
			}

			this.$player = $('iframe');
		}
	}, {
		key: 'initBindings',
		value: function initBindings() {
			var _this2 = this;

			$('body').on({
				click: function click() {

					$('body').addClass('show-overlay');
				}
			}, '[data-project-item]');

			$('body').on({
				click: function click() {
					_this2.closeOverlay();
				}
			}, '[data-overlay-close]');

			$('body').on({
				click: function click() {
					_this2.pauseVideo();
				}
			}, '.owl-prev');

			$('body').on({
				click: function click() {
					_this2.pauseVideo();
				}
			}, '.owl-next');

			$('body').on({
				click: function click(e) {
					_this2.overlayIndex = $(e.currentTarget).index();
					_this2.loadOverlayItems();
					_this2.updateOverlayCarousel();
				}
			}, '[data-project-item]');

			$(document).keydown(function (e) {
				var $overlayCarousel = $('.owl-overlay-carousel').data('owlCarousel');

				if (e.keyCode === 39) {
					$overlayCarousel.next();
				} else if (e.keyCode === 37) {
					$overlayCarousel.prev();
				} else if (e.keyCode === 27) {
					_this2.closeOverlay();
				}
			});

			if (window.addEventListener) {
				window.addEventListener('message', this.onMessageReceived.bind(this), false);
			}
		}
	}, {
		key: 'closeOverlay',
		value: function closeOverlay() {
			$('body').removeClass('show-overlay');
			this.pauseVideo();
		}
	}, {
		key: 'loadOverlayItems',
		value: function loadOverlayItems() {
			var projectItems = [],
			    videoAttr = undefined;

			$('[data-project-item]').each(function () {
				videoAttr = $(this).attr('data-project-videoid');

				if (typeof videoAttr !== typeof undefined && videoAttr !== false) {
					projectItems.push({
						type: $(this).attr('data-project-type'),
						url: $(this).attr('data-project-videoid')
					});
				} else {
					projectItems.push({
						type: $(this).attr('data-project-type'),
						url: $(this).attr('data-project-item')
					});
				}
			});

			$('[data-overlay-content]')[0].innerHTML = this.template({ ProjectItems: projectItems });
			this.$overlayCarousel = $('.owl-overlay-carousel');

			this.updateOverlayCarousel();

			if (this.$overlayCarousel.data('owlCarousel')) {
				this.$overlayCarousel.data('owlCarousel').goTo(this.overlayIndex);
			}
		}
	}, {
		key: 'onMessageReceived',
		value: function onMessageReceived(e) {
			var data;

			if (!/^https?:\/\/player.vimeo.com/.test(e.origin)) {
				return false;
			}

			if (this.playerOrigin === '*') {
				this.playerOrigin = e.origin;
			}

			data = JSON.parse(e.data);

			if (data.event === 'ready') {
				this.onReady();
			}
		}
	}, {
		key: 'onReady',
		value: function onReady() {
			this.post('addEventListener', 'pause');
			this.post('addEventListener', 'finish');
		}
	}, {
		key: 'post',
		value: function post(action, value) {
			var data = {
				method: action
			},
			    message;

			if (value) {
				data.value = value;
			}

			message = JSON.stringify(data);
			this.$player[0].contentWindow.postMessage(message, this.playerOrigin);
		}
	}, {
		key: 'pauseVideo',
		value: function pauseVideo() {
			var data = {
				method: 'pause'
			},
			    message;

			message = JSON.stringify(data);

			if (this.$player[0]) {
				this.$player[0].contentWindow.postMessage(message, this.playerOrigin);
			}
		}
	}]);

	return Overlay;
})();

exports['default'] = Overlay;
module.exports = exports['default'];

},{}],5:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _utilsAppPerformance = require('./utils/app.performance');

var _utilsAppPerformance2 = _interopRequireDefault(_utilsAppPerformance);

var Project = (function () {
	function Project() {
		_classCallCheck(this, Project);

		this.$projectList = $('[data-project-list]');
		this.$loadMoreBtn = $('[data-load-more-button]');
		this.categoryId = _utilsAppPerformance2['default'].getCachedDom().$body.attr('data-category-id');
		this.subCategoryId = _utilsAppPerformance2['default'].getCachedDom().$body.attr('data-subcategory-id');
		this.pageNumber = 0;
		this.pageSize = 9;
		this.selectedAward = '';

		if (this.$projectList) {
			this.initBindings();
		}

		this.template = Handlebars.compile($('#project-list').html());
	}

	_createClass(Project, [{
		key: 'initBindings',
		value: function initBindings() {
			var _this = this;

			_utilsAppPerformance2['default'].getCachedDom().$body.on({
				click: function click(e) {
					_this.pageNumber = 0;

					$('.filter__item').removeClass('selected');

					if (_this.selectedAward !== $(e.currentTarget).attr('data-filter-item')) {
						_this.selectedAward = $(e.currentTarget).attr('data-filter-item');
						$('.filter__item').eq(_this.selectedAward - 1).addClass('selected');
					} else {
						_this.selectedAward = '';
					}

					_this.updateProjects(true);
				}
			}, '[data-filter-item]');

			_utilsAppPerformance2['default'].getCachedDom().$body.on({
				click: function click() {
					_this.loadMoreProjects();
				}
			}, '[data-load-more-button]');

			_utilsAppPerformance2['default'].getCachedDom().$body.on({
				change: function change(e) {
					_this.pageNumber = 0;
					_this.subCategoryId = $(e.currentTarget).val();
					_this.updateProjects(true);
				}
			}, '[data-subcategory-select]');

			_utilsAppPerformance2['default'].getCachedDom().$body.on({
				change: function change(e) {
					_this.pageNumber = 0;
					_this.categoryId = $(e.currentTarget).val();
					_this.updateProjects(true);
				}
			}, '[data-category-select]');

			_utilsAppPerformance2['default'].getCachedDom().$body.on({
				click: function click(e) {
					var data = '',
					    url = e.currentTarget.href;

					e.preventDefault();

					if (_this.categoryId) {
						data = 'category=' + _this.categoryId;
					}

					if (_this.subCategoryId !== undefined) {
						if (data) {
							data += '&';
						}

						data += 'subcategory=' + _this.subCategoryId;
					}

					if (_this.selectedAward !== '') {
						if (data) {
							data += '&';
						}

						data += 'award=' + _this.selectedAward;
					}

					if (data && data !== '') {
						url += '?' + data;
					}

					window.location = url;
				}
			}, '[data-project-list] a');
		}
	}, {
		key: 'loadMoreProjects',
		value: function loadMoreProjects() {
			this.pageNumber++;
			this.updateProjects(false);
			this.$loadMoreBtn.addClass('loading');
		}
	}, {
		key: 'updateProjects',
		value: function updateProjects(remove) {
			var _this2 = this;

			var data = {
				CategoryID: this.categoryId,
				SubCategoryID: this.subCategoryId,
				AwardRank: this.selectedAward,
				PageNumber: this.pageNumber,
				PageSize: this.pageSize
			};

			$.ajax({
				type: 'POST',
				url: '/api/wppedcream/filter/category',
				data: JSON.stringify(data),
				dataType: 'json',
				contentType: 'application/json'
			}).then(function (result) {
				_this2.renderResult(result, remove);
			});
		}
	}, {
		key: 'renderResult',
		value: function renderResult(data, remove) {
			var parsedHtml = this.template(data);

			if (remove) {
				this.$projectList[0].innerHTML = parsedHtml;
				_utilsAppPerformance2['default'].getCachedDom().$htmlbody.animate({ scrollTop: this.$projectList.offset().top - 150 }, 500);
			} else {
				this.$projectList.find('ul').append($(parsedHtml).find('li'));
			}

			if (this.$projectList.find('li').length === data.TotalCount) {
				this.$loadMoreBtn.hide();
			} else {
				this.$loadMoreBtn.show();
			}

			this.$loadMoreBtn.removeClass('loading');
			$('.project-list__item').addClass('show');
		}
	}]);

	return Project;
})();

exports['default'] = Project;
module.exports = exports['default'];

},{"./utils/app.performance":11}],6:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _utilsAppPerformance = require('./utils/app.performance');

var _utilsAppPerformance2 = _interopRequireDefault(_utilsAppPerformance);

var Search = (function () {
	function Search() {
		_classCallCheck(this, Search);

		this.initSearch();
	}

	_createClass(Search, [{
		key: 'initSearch',
		value: function initSearch() {
			var _this = this;

			this.$searchResult = $('[data-search-result]');
			this.$searchInput = $('[data-search-input]');
			this.$searchIcon = $('[data-search-icon]');
			this.$searchClose = $('[data-search-close]');

			this.$searchIcon.on({
				'click tap': function clickTap() {
					_utilsAppPerformance2['default'].getCachedDom().$body.addClass('show-search');
					_this.$searchInput.focus();
				}
			});
			this.$searchClose.on({
				'click tap': function clickTap() {
					_utilsAppPerformance2['default'].getCachedDom().$body.removeClass('show-search');
				}
			});

			this.$searchInput.on({
				keyup: this.searchKeyup.bind(this)
			});

			_utilsAppPerformance2['default'].getCachedDom().$body.on({
				keyup: this.searchItemKeyup.bind(this)
			}, '.search__result__item');

			this.template = Handlebars.compile($('#search-result').html());
		}
	}, {
		key: 'searchKeyup',
		value: function searchKeyup(e) {
			var val = this.$searchInput.val();

			if (val.length > 2) {
				if (e.keyCode === 40 && this.$searchResult.find('.search__result__item').length > 0) {
					this.$searchResult.find('.search__result__item').eq(0).focus();
				} else {
					this.doSearch(val);
				}
			}
		}
	}, {
		key: 'doSearch',
		value: function doSearch(val) {
			var _this2 = this;

			$.ajax({
				type: 'GET',
				url: '/api/wppedcream/search?keyword=' + val,
				contentType: 'application/json; charset=utf-8'
			}).done(function (result) {
				_this2.$searchResult[0].innerHTML = _this2.template(result);
			});
		}
	}, {
		key: 'searchItemKeyup',
		value: function searchItemKeyup(e) {
			var $input = $(e.target),
			    keyCode = e.keyCode;

			if (keyCode === 40) {
				$input.next().focus();
			} else if (keyCode === 38) {
				if ($input.index() > 0) {
					$input.prev().focus();
				} else {
					this.$searchInput.focus();
				}
			}
		}
	}]);

	return Search;
})();

exports['default'] = Search;
module.exports = exports['default'];

},{"./utils/app.performance":11}],7:[function(require,module,exports){
'use strict';

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _app = require('./app');

var _app2 = _interopRequireDefault(_app);

window.WPPCream = new _app2['default']();

},{"./app":3}],8:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var AppAnalytics = (function () {
	function AppAnalytics() {
		_classCallCheck(this, AppAnalytics);

		this.trackingId = window._gaId || false;
		this.isAnalyticsEnabled = true;

		if (this.isAnalyticsEnabled === true) {
			this.initBindings();
			this.injectGA();
		}
	}

	_createClass(AppAnalytics, [{
		key: 'initBindings',
		value: function initBindings() {
			$('body').on({
				click: function click() {
					this.collectGAData($(this));
				}
			}, '[data-ga]');
		}
	}, {
		key: 'injectGA',
		value: function injectGA() {
			var i = window,
			    s = document,
			    o = 'script',
			    g = '//www.google-analytics.com/analytics.js',
			    r = 'ga',
			    a,
			    m;

			if (!this.trackingId) {
				return;
			}

			i.GoogleAnalyticsObject = r;

			i[r] = i[r] || function () {
				(i[r].q = i[r].q || []).push(arguments);
			};

			i[r].l = new Date();

			a = s.createElement(o);
			m = s.getElementsByTagName(o)[0];

			a.async = 1;
			a.src = g;
			m.parentNode.insertBefore(a, m);

			ga('create', this.trackingId, 'auto');
			ga('require', 'displayfeatures');
			ga('send', 'pageview');
			ga('require', 'linker');
		}
	}, {
		key: 'pageView',
		value: function pageView(url) {
			if (window.ga) {
				window.ga('send', 'pageview', url);
			}
		}
	}, {
		key: 'collectGAData',
		value: function collectGAData($obj) {
			var type = $obj.attr('data-ga-type') || false,
			    data;

			if (type === 'event') {
				data = {};
				data.category = $obj.attr('data-ga-category');
				data.action = $obj.attr('data-ga-action');
				data.label = $obj.attr('data-ga-label');
				this.trackEvent(data.category, data.action, data.label);
			}
		}
	}, {
		key: 'trackEvent',
		value: function trackEvent(category, action, label, value) {
			try {
				if (value) {
					ga('send', 'event', category, action, label, value);
				} else {
					ga('send', 'event', category, action, label);
				}
			} catch (e) {
				console.warn('Analytics error!');
			}
		}
	}]);

	return AppAnalytics;
})();

exports['default'] = AppAnalytics;
module.exports = exports['default'];

},{}],9:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var AppForm = (function () {
	function AppForm() {
		_classCallCheck(this, AppForm);

		this.initSelect();
	}

	_createClass(AppForm, [{
		key: 'initSelect',
		value: function initSelect() {

			$('.selectboxit').selectBoxIt({
				showFirstOption: false,
				autoWidth: false
			});
		}
	}]);

	return AppForm;
})();

exports['default'] = AppForm;
module.exports = exports['default'];

},{}],10:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var AppHandlebarsHelpers = (function () {
	function AppHandlebarsHelpers() {
		_classCallCheck(this, AppHandlebarsHelpers);

		this.initHandlebarsHelpers();
	}

	_createClass(AppHandlebarsHelpers, [{
		key: 'initHandlebarsHelpers',
		value: function initHandlebarsHelpers() {

			Handlebars.registerHelper('toLowerCase', function (str) {
				return str.toLowerCase();
			});

			Handlebars.registerHelper('eq', function (v1, v2, options) {
				if (v1 === v2) {
					return options.fn(this);
				}
				return options.inverse(this);
			});
		}
	}]);

	return AppHandlebarsHelpers;
})();

exports['default'] = AppHandlebarsHelpers;
module.exports = exports['default'];

},{}],11:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var AppPerformance = (function () {
	function AppPerformance() {
		_classCallCheck(this, AppPerformance);

		this.windowResize = null;

		this.initCacheDOM();
		this.initBindings();
		this.saveDeviceProperties();
	}

	_createClass(AppPerformance, [{
		key: 'initCacheDOM',
		value: function initCacheDOM() {
			AppPerformance.$cachedDOM = {
				window: window,
				$window: $(window),
				$body: $(document.body),
				$html: $('html'),
				$head: $('head'),
				$htmlbody: $('html, body')
			};
		}
	}, {
		key: 'initBindings',
		value: function initBindings() {
			$(window).on('resize', this.saveDeviceProperties.bind(this));
		}
	}, {
		key: 'saveDeviceProperties',
		value: function saveDeviceProperties() {
			var w = window,
			    d = document,
			    e = d.documentElement,
			    g = d.getElementsByTagName('body')[0],
			    W = w.innerWidth || e.clientWidth || g.clientWidth,
			    H = w.innerHeight || e.clientHeight || g.clientHeight;

			AppPerformance.deviceProperties = {
				connection: navigator.connection ? navigator.connection : 'unknown',
				pixelRatio: window.devicePixelRatio,
				window: {
					width: W,
					height: H
				}
			};
		}
	}], [{
		key: 'getCachedDom',
		value: function getCachedDom() {
			return this.$cachedDOM;
		}
	}]);

	return AppPerformance;
})();

exports['default'] = AppPerformance;
module.exports = exports['default'];

},{}],12:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _appPerformance = require('./app.performance');

var _appPerformance2 = _interopRequireDefault(_appPerformance);

var AppSvg = (function () {
	function AppSvg() {
		_classCallCheck(this, AppSvg);

		this.settings = {
			svgUrl: '/i/sprite/sprite-app.svg'
		};

		this.initDOMElements();
		this.loadSvg();
	}

	_createClass(AppSvg, [{
		key: 'initDOMElements',
		value: function initDOMElements() {
			this.$body = _appPerformance2['default'].getCachedDom().$body;
		}
	}, {
		key: 'loadSvg',
		value: function loadSvg() {
			var _this = this;

			var $promise = $.ajax({
				type: 'GET',
				url: this.$body.attr('data-root-path') + this.settings.svgUrl,
				dataType: 'html',
				contentType: 'application/json; charset=utf-8'
			});

			$.when($promise).then(function (result) {
				return _this.addSpriteToDOM(result);
			});
		}
	}, {
		key: 'addSpriteToDOM',
		value: function addSpriteToDOM(sprite) {
			this.$body.find('[data-svgsprite]').remove();
			this.$body.append('<div class="block--display-none" data-svgsprite>' + sprite + '</div>');
		}
	}]);

	return AppSvg;
})();

exports['default'] = AppSvg;
module.exports = exports['default'];

},{"./app.performance":11}]},{},[7]);
